import { FC } from 'react'
import styles from './campaignCategoryPicker.module.scss'

const CATEGORIES = [
  'Brand Management',
  'Competitor Analysis',
  'Market Research',
]

interface CampaignCategoryPickerProps {
  exclude?: string[]
  // Defaults to "Campaign Category"; Review Analysis says "Facility Category".
  label?: string
  onChange: (category: string) => void
  value: string
}

export const CampaignCategoryPicker: FC<CampaignCategoryPickerProps> = ({
  exclude,
  label = 'Campaign Category',
  onChange,
  value,
}) => {
  const filtered = exclude
    ? CATEGORIES.filter((c) => !exclude.includes(c))
    : CATEGORIES

  return (
    <div className={styles.wrapper}>
      <label className={styles.label}>{label}</label>
      <div className={styles.cards}>
        {filtered.map((cat) => (
          <button
            className={`${styles.card} ${value === cat ? styles.selected : ''}`}
            key={cat}
            onClick={() => onChange(value === cat ? '' : cat)}
            type="button"
          >
            <span className={styles.radio}>
              {value === cat && <span className={styles.radioInner} />}
            </span>
            {cat}
          </button>
        ))}
      </div>
    </div>
  )
}
